(function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
"use strict";

require("core-js/stable");
require("regenerator-runtime/runtime");
require("core-js/features/object/assign.js");
require("core-js/features/array/find.js");
require("core-js/features/array/find-index.js");
require("core-js/features/array/fill.js");
require("core-js/features/array/includes.js");
require("core-js/features/array/from.js");
require("core-js/features/promise/index.js");
require("core-js/features/promise/finally.js");
require("whatwg-fetch");
require("abortcontroller-polyfill/dist/polyfill-patch-fetch");
require("core-js/es/map/index.js");
require("core-js/es/set/index.js");
// window.fetch

// for react 16
// https://facebook.github.io/react/blog/2017/09/26/react-v16.0.html#javascript-environment-requirements

// Source: https://github.com/jserz/js_piece/blob/master/DOM/NonDocumentTypeChildNode/nextElementSibling/nextElementSibling.md
(function (arr) {
  arr.forEach(function (item) {
    if (item.hasOwnProperty("nextElementSibling")) {
      return;
    }
    Object.defineProperty(item, "nextElementSibling", {
      configurable: true,
      enumerable: true,
      get: function get() {
        var el = this;
        while (el = el.nextSibling) {
          if (el.nodeType === 1) {
            return el;
          }
        }
        return null;
      },
      set: undefined
    });
  });
})([Element.prototype, CharacterData.prototype]);

},{"abortcontroller-polyfill/dist/polyfill-patch-fetch":"abortcontroller-polyfill/dist/polyfill-patch-fetch","core-js/es/map/index.js":"core-js/es/map/index.js","core-js/es/set/index.js":"core-js/es/set/index.js","core-js/features/array/fill.js":"core-js/features/array/fill.js","core-js/features/array/find-index.js":"core-js/features/array/find-index.js","core-js/features/array/find.js":"core-js/features/array/find.js","core-js/features/array/from.js":"core-js/features/array/from.js","core-js/features/array/includes.js":"core-js/features/array/includes.js","core-js/features/object/assign.js":"core-js/features/object/assign.js","core-js/features/promise/finally.js":"core-js/features/promise/finally.js","core-js/features/promise/index.js":"core-js/features/promise/index.js","core-js/stable":"core-js/stable","regenerator-runtime/runtime":"regenerator-runtime/runtime","whatwg-fetch":"whatwg-fetch"}]},{},[1]);
